import React, { useState, useEffect } from 'react';
import CommonLayout from '../../layouts/CommonLayout';
import MyMeetingApplicationContainer from '../../containers/MyMeetingApplicationContainer';
import { getMyMeetingApplications } from '../../../api/MeetingApplicationApi';
import useLoadingStore from '../../../store/loadingStore';
import { IoTimeOutline } from 'react-icons/io5';

const MyPendingMeetingApplicationListPage = () => {
    const [applications, setApplications] = useState([]);
    const { setIsLoading } = useLoadingStore();

    useEffect(() => {
        loadApplications();
    }, []);

    const loadApplications = async () => {
        try {
            setIsLoading(true);
            const response = await getMyMeetingApplications();
            setApplications(response);
        } catch (error) {
            console.error('신청서 목록 조회 실패:', error);
            alert('신청서 목록을 불러오는 중 오류가 발생했습니다.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <CommonLayout title="승인 대기중인 모임">
            <div className="max-w-lg mx-auto">
                <div className="p-4">
                    {applications.length === 0 ? (
                        <div className="flex flex-col items-center justify-center h-64 text-gray-500">
                            <IoTimeOutline size={64} className="text-gray-400 mb-4" />
                            <p className="text-center">
                                승인 대기중인 모임이 없습니다
                            </p>
                        </div>
                    ) : (
            <div>
                            <p className="text-sm text-gray-600 mb-4">
                                총 {applications.length}개의 모임 참가 신청이 대기중입니다
                            </p>
                            {applications.map((application) => (
                                <MyMeetingApplicationContainer
                                    key={application.id}
                                    application={application}
                                />
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </CommonLayout>
    );
};

export default MyPendingMeetingApplicationListPage;
